import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { CommonFieldProps } from '../form.types';
import { TextField as MUITextField } from '@mui/material';

export type TextFieldProps<T extends FieldValues> = CommonFieldProps<T> & {
  type: 'text';
  multiline?: boolean;
  rows?: number;
  minRows?: number;
  placeholder?: string;
};

export const TextField = <T extends FieldValues>({
  name,
  label,
  multiline,
  rows,
  minRows,
  placeholder
}: TextFieldProps<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <MUITextField
          {...field}
          label={label}
          onChange={field.onChange}
          multiline={multiline}
          rows={rows}
          minRows={minRows}
          placeholder={placeholder}
        />
      )}
    />
  );
};
